import {
	ComIbmCommerceRestOrderHandlerOrderExportHandlerOrderExportRequest,
	ComIbmCommerceRestOrderHandlerOrderExportHandlerOrderExportResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class OrderExport<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags Order Export
	 * @name ExportOrders
	 * @summary Exports orders for a store.
	 * @request POST:/store/{storeId}/order_export
	 * @secure
	 * @response `200` `ComIbmCommerceRestOrderHandlerOrderExportHandlerOrderExportResponse` The requested completed successfully.
	 * @response `400` `void` Bad request. Some of the inputs provided to the request aren't valid.
	 * @response `401` `void` Not authenticated. The user session isn't valid.
	 * @response `403` `void` The user isn't authorized to perform the specified request.
	 * @response `404` `void` The specified resource couldn't be found.
	 * @response `500` `void` Internal server error. Additional details will be contained on the server logs.
	 */
	exportOrders = (
		storeId: string,
		data?: ComIbmCommerceRestOrderHandlerOrderExportHandlerOrderExportRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (loggerCan('trace') && (!this.http.traceDetails || this.http.traceDetails['exportOrders'])) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/order_export`,
				params: _params,
				body: data,
				methodName: 'exportOrders',
			};
			logger.trace(traceData);
		}
		return this.http.request<
			ComIbmCommerceRestOrderHandlerOrderExportHandlerOrderExportResponse,
			void
		>({
			path: `/store/${storeId}/order_export`,
			method: 'POST',
			body: data,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
